"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MergeDocumentImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing MergeDocument operations. */
var MergeDocumentImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class MergeDocument class.
   * @param client Reference to the service client
   */
  function MergeDocumentImpl(client) {
    (0, _classCallCheck2["default"])(this, MergeDocumentImpl);
    this.client = client;
  }
  /**
   *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
   * @param portalId (Access Controlled)
   * @param hiveId (Access Controlled)
   * @param fullName (Access Controlled)
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(MergeDocumentImpl, [{
    key: "getMergeDocuments",
    value: function getMergeDocuments(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getMergeDocumentsOperationSpec);
    }
  }]);
  return MergeDocumentImpl;
}(); // Operation Specifications


exports.MergeDocumentImpl = MergeDocumentImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getMergeDocumentsOperationSpec = {
  path: "/api/Portals({portalId})/Document/MergeDocuments/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "MergeDocumentViewModel"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};